import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
  SliceCaseReducers,
} from "@reduxjs/toolkit";
import { CommentMentionablesType, CommentNotificationType } from "operations/schema/schema";
import { RootState } from "store";
import { asyncMutations, mutationBuilder } from "./comments.mutations";
import { asyncQueries, queryBuilder } from "./comments.queries";

export interface State {
  notifications: CommentNotificationType[];
  mentionables: CommentMentionablesType;
  mentionsLoading: boolean;
  notificationsOpen: boolean;
  loading: boolean;
  lastLoaded: string | null;
}

interface Reducers extends SliceCaseReducers<State> {
  setNotificationsOpen: (state: State, action: PayloadAction<{ open: boolean }>) => State;
}

interface Selectors {
  selectNotificationsCount: (state: RootState) => number;
}

export const initialState: State = {
  notifications: [],
  mentionables: {
    defaultMainServiceTeam: false,
    defaultTaskCreator: false,
  },
  mentionsLoading: false,
  notificationsOpen: false,
  loading: false,
  lastLoaded: null,
};

const selectors: Selectors = {
  selectNotificationsCount: ({ comments: notifications }) => {
    return notifications.notifications.filter((x) => !x.notificationRead).length;
  },
};

const reducers: Reducers = {
  setNotificationsOpen: (state, { payload: { open } }) => {
    state.notificationsOpen = open;
    return state;
  },
};

const storeBase = createSlice<State, Reducers>({
  name: "calendar",
  initialState,
  reducers,
  extraReducers: (builder: ActionReducerMapBuilder<State>) => {
    queryBuilder(builder);
    mutationBuilder(builder);
  },
});

export default storeBase.reducer;
export const { setNotificationsOpen } = storeBase.actions;
export const { getNotifications, getMentionables } = asyncQueries;
export const { markAsRead, addComment, updateComment, deleteComment } = asyncMutations;
export const { selectNotificationsCount } = selectors;
